import React, { useId } from "react";
import { motion } from "framer-motion";
type Option<T extends string> = {
  value: T;
  label: string;
  hint?: string;
};
type SegmentedControlProps<T extends string> = {
  options: Option<T>[];
  value: T;
  onChange: (value: T) => void;
  label: string;
  tone?: "light" | "dark";
  className?: string;
};
export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  label,
  tone = "light",
  className = ""
}: SegmentedControlProps<T>) {
  const id = useId();
  const dark = tone === "dark";
  return <div role="group" aria-label={label} className={`grid rounded-full p-1 ${dark ? "bg-paper/10" : "bg-cream ring-1 ring-line"} ${className}`} style={{
    gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))`
  }} data-id="element-290" data-mp="3s1nncnnk7s4">
      {options.map(o => {
      const active = o.value === value;
      return <button key={o.value} type="button" aria-pressed={active} onClick={() => onChange(o.value)} className={`relative rounded-full px-3 py-2 text-[13px] font-semibold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-gold ${active ? dark ? "text-forestDeep" : "text-paper" : dark ? "text-paper/70" : "text-forest"}`} data-id="element-291" data-mp="1p4w2vfl9b3uq">
            {active && <motion.span layoutId={`seg-${id}`} className={`absolute inset-0 rounded-full ${dark ? "bg-gold" : "bg-forest"}`} transition={{
          type: "spring",
          duration: 0.3,
          bounce: 0.15
        }} data-id="element-292" data-mp="2snr52yk5u0du" />}
            <span className="relative block whitespace-nowrap" data-id="element-293" data-mp="2iw4vt7rdubdq">{o.label}</span>
            {o.hint && <span className="relative block whitespace-nowrap text-[11px] font-medium opacity-80" data-id="element-294" data-mp="2eygvtqau1sez">{o.hint}</span>}
          </button>;
    })}
    </div>;
}